import React, { ReactNode, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { IN_DEVELOPMENT_MESSAGE, smartAuditOpenToAll } from '@app/api/backendProfile';
import { notificationController } from '@app/controllers/notificationController';

/**
 * Lets every session into Smart Audit once `REACT_APP_SMART_AUDIT_FOR_ALL=true`. Any other session gets
 * "Đang phát triển" once and goes back to `/`; the children (the lazy module) are not rendered, so its chunk is
 * never loaded (spec R4, §5.5).
 */
const SmartAuditGate: React.FC<{ children: ReactNode }> = ({ children }) => {
  const allowed = smartAuditOpenToAll();

  // An effect, not the render, so the notice shows once per visit (React 17 runs mount effects once).
  useEffect(() => {
    if (!allowed) notificationController.info({ message: IN_DEVELOPMENT_MESSAGE });
  }, [allowed]);

  return allowed ? <>{children}</> : <Navigate to="/" replace />;
};

export default SmartAuditGate;
